module.exports = __webpack_public_path__ + "static/media/isletgrowth-Figure5-L.d87c141f.jpg";